var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastTrack2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9 62.7c-2.5 0-4.4 2-4.2 4.5a5 5 0 004.8 4.6c2.5 0 4.4-2 4.2-4.6a5 5 0 00-4.8-4.5zM77 62.7a4 4 0 00-4.1 4.5 5 5 0 004.9 4.6 4 4 0 004-4.6 5 5 0 00-4.8-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9 63.3l-.8-8.8c-.2-2-1.7-2.8-3.8-3.5l-8.6-2.3-5.7-9.2c-1.8-2.6-3-3.4-7.9-3.4H25.7a3.2 3.2 0 00-3.1 3.2l.1 2.4.2 1.7V45l.2 1.7.1 2.3.2 1.7v1.7l.2 1.7.2 2.3v1.7L24 60l.2 3.4c.2 1.9 1.8 3.5 3.7 3.5H31c0-3.9 2.9-7 6.7-7a8 8 0 017.7 7h24.7c0-2.3.9-4.5 2.8-5.8 3.2-2.1 7.7-1.1 10.1 2.3a8 8 0 011.5 3.5h2.2a3 3 0 003.1-3.5zM72.3 49H59.6a.5.5 0 01-.5-.5l-.7-8.4c0-.2.2-.4.4-.4h8.3c.2 0 .6 0 .8.4l4.8 8.4c0 .3-.1.5-.4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 43H23c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H11.8a1 1 0 01-1-.8l-.5-2a1 1 0 011-1.2zM8.3 49H25c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H8.8a1 1 0 01-1-.8l-.5-2a1 1 0 011-1.2zM15.3 55H32c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H15.8a1 1 0 01-1-.8l-.5-2a1 1 0 011-1.2z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 55h57v12H30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastTrack2);
export default __webpack_public_path__ + "static/media/fast_track2.7fe0ab7ab212b15e68bd0ef1b4a01fa5.svg";
export { ForwardRef as ReactComponent };